import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { CategoryDirective } from '@app/core/directives/category.directive';
import { List } from '@app/core/interfaces/list';
import {
  GallerySelectors,
  ListingsSelectors,
  LoadLatestSearchRequests,
} from '@app/store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CarouselComponent } from '../carousel/carousel.component';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, CategoryDirective, CarouselComponent],
})
export class CategoriesComponent implements OnInit {
  constructor(private store: Store) {}

  categories$: Observable<List | undefined> = inject(Store).select(
    ListingsSelectors.categories,
  );

  selectedCategory$: Observable<string | undefined> = inject(Store).select(
    GallerySelectors.category,
  );

  ngOnInit(): void {
    this.store.dispatch(new LoadLatestSearchRequests());
  }
}
